import { Component } from '@angular/core';
import { PriceList } from 'src/app/assabil-kernel/models/entities/master-data/price-list-entity';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';


@Component({
  selector: 'price-list-lov',
  templateUrl: './price-list-lov.component.html',
  styleUrls: ['./price-list-lov.component.scss']
})


export class PriceListLovComponent extends GenericLovComponent   {

    code         : string; 
    name         : string; 

    priceLists: PriceList[] = [];

    columns = [
        {  prop: 'priceListCode',   name: 'Code'},
        {  prop: 'name',            name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<PriceListLovComponent>,
    protected masterDataService  : MasterDataService) {
    super();
    this.entityName = "priceList";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
this.masterDataService.priceListsGet(this.code).then(result => {
    this.priceLists = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : PriceList){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------


}
